import { EMBER_ROUTE_NAMES } from './routes';
import { DATA_ATTRIBUTES } from 'sh-www/constants/data-attributes';

/*
|---------------------------------------------------------------------------------------------------
| General
|---------------------------------------------------------------------------------------------------
*/

/** Represents src/alt details for the Glimmer logo. */
export const SH_LOGO_DETAILS = {
  src: 'https://res.cloudinary.com/ddsqycvoq/image/upload/glimmer/favicon_dark.svg',
  alt: 'Glimmer',
};

/*
|---------------------------------------------------------------------------------------------------
| Admin
|---------------------------------------------------------------------------------------------------
*/

/** The titles in the navigation. */
export const ADMIN_ROUTE_PARENT_NAMES = {
  ACCOUNTING: 'Accounting',
};

/** The map of route parent names to the sub-navigation model map. */
export const ADMIN_ROUTE_PARENT_NAME__SUB_NAV_MODEL_MAP = {
  [ADMIN_ROUTE_PARENT_NAMES.ACCOUNTING]: {
    [EMBER_ROUTE_NAMES.ADMIN__ACCOUNTING__ACCOUNTS_AGING]: 'Accounts Aging',
    [EMBER_ROUTE_NAMES.ADMIN__ACCOUNTING__ACCOUNTS_RECEIVABLE]: 'Accounts Receivable',
    [EMBER_ROUTE_NAMES.ADMIN__ACCOUNTING__PAYIN]: 'Payin',
    [EMBER_ROUTE_NAMES.ADMIN__ACCOUNTING__PAYOUT]: 'Payout',
  },
}

/*
|---------------------------------------------------------------------------------------------------
| Buyer
|---------------------------------------------------------------------------------------------------
*/

/** The titles in the navigation. */
export const BUYER_ROUTE_PARENT_NAMES = {
  STORIES: 'Projects',
  PEOPLE: 'People',
  MESSAGES: 'Messages',
  REPORTS: 'Reports',
};

/** The map of route parent names to the route object. */
export const BUYER_ROUTE_PARENT_NAME__PRIMARY_ROUTE_MAP = {
  [BUYER_ROUTE_PARENT_NAMES.STORIES]: {
    route: EMBER_ROUTE_NAMES.POSTINGS__LIVE
  },
  [BUYER_ROUTE_PARENT_NAMES.PEOPLE]: {
    route: EMBER_ROUTE_NAMES.PEOPLE_CENTER__MY_NETWORK
  },
  [BUYER_ROUTE_PARENT_NAMES.MESSAGES]: {
    route: EMBER_ROUTE_NAMES.MESSAGE_CENTER__INBOX
  },
  [BUYER_ROUTE_PARENT_NAMES.REPORTS]: {
    route: EMBER_ROUTE_NAMES.COMPANY_ANALYTICS__PROJECTS
  },
};

/** The map of route parent names to the sub-navigation model map. */
export const BUYER_ROUTE_PARENT_NAME__SUB_NAV_MODEL_MAP = {
  [BUYER_ROUTE_PARENT_NAMES.STORIES]: {
    [EMBER_ROUTE_NAMES.POSTINGS__LIVE]: 'Postings',
    [EMBER_ROUTE_NAMES.PROJECTS__IN_PROGRESS]: 'Projects',
  },
  [BUYER_ROUTE_PARENT_NAMES.PEOPLE]: {
    [EMBER_ROUTE_NAMES.PEOPLE_CENTER__MY_NETWORK]: {
      text: 'My Network',
      dataCategory: DATA_ATTRIBUTES.CATEGORY.CMP,
      dataComponent: DATA_ATTRIBUTES.COMPONENT.NAV_ITEM,
      dataRef: DATA_ATTRIBUTES.REF.CMP_MY_NETWORK_NAV
    },
    [EMBER_ROUTE_NAMES.PEOPLE_CENTER__SEARCH]: {
      text: 'Find Creators',
      dataCategory: DATA_ATTRIBUTES.CATEGORY.CMP,
      dataComponent: DATA_ATTRIBUTES.COMPONENT.NAV_ITEM,
      dataRef: DATA_ATTRIBUTES.REF.CMP_SEARCH_NAV
    },
  },
  [BUYER_ROUTE_PARENT_NAMES.MESSAGES]: {
    [EMBER_ROUTE_NAMES.MESSAGE_CENTER__INBOX]: 'Inbox',
    [EMBER_ROUTE_NAMES.MESSAGE_CENTER__ARCHIVE]: 'Archive',
  },
  [BUYER_ROUTE_PARENT_NAMES.REPORTS]: {
    [EMBER_ROUTE_NAMES.COMPANY_ANALYTICS__PROJECTS]: 'Projects',
    [EMBER_ROUTE_NAMES.COMPANY_ANALYTICS__FREELANCERS]: 'Freelancers',
    [EMBER_ROUTE_NAMES.COMPANY_ANALYTICS__INVOICES]: 'Invoices',
    [EMBER_ROUTE_NAMES.COMPANY_ANALYTICS__CREDITS]: 'Credits',
  },
};

/*
|---------------------------------------------------------------------------------------------------
| Seller
|---------------------------------------------------------------------------------------------------
*/

/** The titles in the navigation. */
export const SELLER_ROUTE_PARENT_NAMES = {
  POSTINGS: 'Postings',
  PROJECTS: 'Projects',
  MESSAGES: 'Messages',
  REPORTS: 'Reports',
};

/** The map of route parent names to the route object. */
export const SELLER_ROUTE_PARENT_NAME__PRIMARY_ROUTE_MAP = {
  [SELLER_ROUTE_PARENT_NAMES.POSTINGS]: {
    route: EMBER_ROUTE_NAMES.POSTINGS__FIND_WORK,
  },
  [SELLER_ROUTE_PARENT_NAMES.PROJECTS]: {
    route: EMBER_ROUTE_NAMES.PROJECTS__INDEX,
  },
  [SELLER_ROUTE_PARENT_NAMES.MESSAGES]: {
    route: EMBER_ROUTE_NAMES.MESSAGE_CENTER__INBOX,
  },
  [SELLER_ROUTE_PARENT_NAMES.REPORTS]: {
    route: EMBER_ROUTE_NAMES.COMPANY_ANALYTICS__PROJECTS,
  },
};

/** The map of route parent names to the sub-navigation model map. */
export const SELLER_ROUTE_PARENT_NAME__SUB_NAV_MODEL_MAP = {
  [SELLER_ROUTE_PARENT_NAMES.POSTINGS]: {
    [EMBER_ROUTE_NAMES.POSTINGS__FIND_WORK]: 'Find Work',
    [EMBER_ROUTE_NAMES.POSTINGS__APPLICATIONS]: 'Applications',
  },

  // Projects is not currently an Ember route.
  [SELLER_ROUTE_PARENT_NAMES.PROJECTS]: null,

  [SELLER_ROUTE_PARENT_NAMES.MESSAGES]: {
    [EMBER_ROUTE_NAMES.MESSAGE_CENTER__INBOX]: 'Inbox',
    [EMBER_ROUTE_NAMES.MESSAGE_CENTER__ARCHIVE]: 'Archive'
  },

  [SELLER_ROUTE_PARENT_NAMES.REPORTS]: {
    [EMBER_ROUTE_NAMES.COMPANY_ANALYTICS__PROJECTS]: 'By Year',
    [EMBER_ROUTE_NAMES.COMPANY_ANALYTICS__TOTALS]: 'Total',
  },
};
